<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MvZbkG/tc-custom/9781439676431.jpg?1704586019441" alt="This image is the cover for the book Black Homesteaders of the South"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Homesteaders of the South
      </h1>
      <p class="bookDescription body article font2">
        <p><b> Meet the black men and women who toiled from sunup to sundown to live the American dream.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bernice Alexander Bennett
      </h2>
      
      <p class="authorDescription body article">Bernice Alexander Bennett is an award-winning author, genealogist, nationally recognized guest speaker, storyteller and producer-host of the popular <I>Research at the National Archives and Beyond</I> BlogTalkRadio program. She is also the first recipient of the Ida B. Wells Service Award, given by the Sons and Daughters of the United States Middle Passage, for her dedication to broadcast stories about enslaved and indentured ancestors of African descent. She also received the Elizabeth Clark-Lewis Afro-American Historical and Genealogical Society (AAHGS) Genealogy Award in 2019 for original research in support of African American genealogy. Bennett is a volunteer with the Homestead National Historical Park Service and has devoted her grass-roots skills to identifying and encouraging descendants of Black homesteaders to share their stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c9319956